import PropTypes from 'prop-types';
import React from 'react';
import {
	Modal,
	Box,
	DialogTitle,
	DialogContent,
	DialogContentText
} from '@mui/material';
import SuccessImgIcon from '../../Assets/Images/EsignGatewaySuccess.svg';
import RejectedImgIcon from '../../Assets/Images/EsignGatewayReject.svg';
import PrimaryButton from './Button/primary-button.js';

const styles = {
	title: {
		fontFamily: 'Gilroy-Medium',
		fontSize: '20px',
		fontWeight: 400,
		lineHeight: '24px',
		letterSpacing: '0em',
		textAlign: 'center'
	},
	message: {
		fontFamily: 'Gilroy-Medium',
		fontSize: '14px',
		lineHeight: '16px',
		letterSpacing: '0em',
		textAlign: 'center',
		color: '#646464'
	},
	content: {
		backgroundColor: 'white',
		padding: '40px 16px 20px',
		borderRadius: '8px',
		display: 'flex',
		flexDirection: 'column',
		position: 'relative',
		width: '100%'
	},
	modalContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	successImg: {
		transform: 'translateY(50%)',
		zIndex: 1,
		position: 'relative'
	}
};

const SuccessRejectPopUp = ({
	open = false,
	title = '',
	message = '',
	actionLabel = '',
	modalContentWidth = '',
	success = false,
	handleClose = () => {},
	showImage = true,
	children
}) => (
	<Modal open={open} style={styles.modalContent}>
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				outline: 'none',
				border: 'none',
				width: modalContentWidth
			}}
		>
			{showImage && (
				<div>
					<img
						src={success ? SuccessImgIcon : RejectedImgIcon}
						alt='Success'
						style={styles.successImg}
					/>
				</div>
			)}
			<div style={styles.content}>
				<DialogTitle sx={styles.title}>{title}</DialogTitle>
				<DialogContent sx={{ padding: '0 5px 16px' }}>
					{Boolean(message) && (
						<DialogContentText sx={styles.message}>{message}</DialogContentText>
					)}
					{children}
				</DialogContent>
				<div>
					<PrimaryButton
						value={actionLabel}
						onClick={handleClose}
						width='100%'
						textcolor={success ? '#000' : '#fff'}
						backgroundColor={success ? '#B7D423' : '#E96666'}
						padding='8px 16px'
						borderRadius='8px'
					/>
				</div>
			</div>
		</Box>
	</Modal>
);

export default SuccessRejectPopUp;

SuccessRejectPopUp.propTypes = {
	open: PropTypes.any,
	title: PropTypes.any,
	message: PropTypes.any,
	actionLabel: PropTypes.any,
	modalContentWidth: PropTypes.any,
	success: PropTypes.any,
	handleClose: PropTypes.any,
	showImage: PropTypes.any,
	children: PropTypes.any
};
